export class ToogleModalQrCode {
  static readonly type = '[Config] SHOW/HIDE MODAL QR CODE';
}

export class SetActiveRoute {
  static readonly type = '[Config] Select active trading program route';
  constructor(public route: string) {}
}
